import * as createBlockUtils from '../../../utils/create-block';

import { CompositeQABlock } from './composite-qa-block';
import { resolveFields } from './resolve-fields';
import { ICompositeQABlock } from './types';

const createCompositeQABlock = createBlockUtils.makeBlockFactory<ICompositeQABlock>(
  { withExampleAnswersJson: true, withPageSelect: true },
  {
    label: 'Composite questions and answers',
    render: CompositeQABlock,
    resolveFields,
  }
);

export { createCompositeQABlock };
